import { useUserContext } from '../../contexts/AuthProvider';
import { useSelectedFilterValues, useEnvironment } from '@publicisgroupe/p-os-components';
import { AppSettings } from '../../types/appSettings';
import { getCookie, getEmailDomain } from 'utils/helpers';
import { COOKIE_ACCEPT, POS_COOKIE_SETTINGS } from 'utils/constants';

export const usePendoIntegration = () => {
  const loadPendoScript = (apiKey: string) => {
    const pendoScript = document.getElementById('pendo-script');
    if (!pendoScript) return;
    const loadPendoScript = (window as any).loadPendoScript;
    if (typeof loadPendoScript !== 'function') return;
    loadPendoScript(apiKey);
  };

  const { client, country, product, region, brandCategory, brand } = useSelectedFilterValues();
  const { settings } = useEnvironment();
  const { userInfo } = useUserContext();

  if (!client || !settings || !userInfo) {
    return;
  }

  const visitor = {
    id: window.userHash ?? '',
    role: userInfo.userType,
    emaildomain: client.toLowerCase().includes('stellantis')
      ? userInfo.userEmail
      : getEmailDomain(userInfo.userEmail),
  };

  const account = {
    id: client,
    client,
    country,
    product,
    region,
    brandCategory,
    brand,
  };

  if (getCookie(POS_COOKIE_SETTINGS) === COOKIE_ACCEPT) {
    if ((window as any).pendo) {
      (window as any).pendo.updateOptions({ visitor, account });
    } else {
      const pendoApiKey = (settings as AppSettings).pendoApiKey;

      loadPendoScript(pendoApiKey);
      (window as any).pendo.initialize({ visitor, account });
    }
  }
};
